import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../../../hooks/useSEO.js";

import data from "../../../Data/specialists/specialistsData.json";
import specialistsSeoData from "../../../Data/specialists/specialistsSeoData.js";

function getSpecialization(person) {
  if (!person || !person.position) return "врач";

  const txt = `${person.position} ${person.department || ""}`.toLowerCase();

  if (txt.includes("дермат")) return "дерматовенеролог";
  if (txt.includes("гинек")) return "гинеколог";
  if (txt.includes("уролог")) return "уролог";
  if (txt.includes("невр")) return "невролог";
  if (txt.includes("терап")) return "терапевт";
  if (txt.includes("ультразв")) return "врач УЗИ";

  return "врач";
}

export default function SpecialistsDetail() {
  const { slug } = useParams();

  const person = data.find((p) => p.slug === slug) || null;

  const seoData = person
    ? specialistsSeoData[person.slug]
    : {
        title: "Сотрудник не найден | УРНИИДВИ",
        description: "Страница специалиста временно недоступна.",
        keywords: "врач, специалист, УРНИИДВИ",
        seoText: "Информация о специалисте не найдена.",
      };

  // ХУК ВЫЗЫВАЕТСЯ БЕЗУСЛОВНО ОДИН РАЗ
  useSEO({
    title: seoData.title,
    description: seoData.description,
    keywords: seoData.keywords,
    url: person
      ? `/patients/specialists/${person.slug}`
      : "/patients/specialists",
    noindex: !person,
  });

  if (!person) {
    return <p>Сотрудник не найден</p>;
  }

  const spec = getSpecialization(person);

  return (
    <section className="contacts education staff-detail">
      <Breadcrumbs />

      <div className="staff-detail__wrapper">
        <div className="staff-detail__photo">
          <img src={person.photo} alt={`${person.name} ${spec}`} />
        </div>

        <div className="staff-detail__info">
          <h1 className="staff-detail__name">{person.name}</h1>

          <h2 className="staff-detail__position">{person.position}</h2>

          {person.education && (
            <p className="staff-detail__text">{person.education}</p>
          )}

          {person.documents?.length > 0 && (
            <div className="staff-detail__bio">
              {person.documents.map(
                (doc, index) => doc && <p key={index}>{doc}</p>,
              )}
            </div>
          )}

          {(person.category || person.degree) && (
            <p className="staff-detail__text">
              {person.category}
              {person.degree ? ` / ${person.degree}` : ""}
            </p>
          )}

          {person.experience && (
            <p className="staff-detail__text">{person.experience}</p>
          )}

          {person.direction && (
            <p className="staff-detail__text">{person.direction}</p>
          )}

          {/* <div className="staff-detail__seo-text">
            <p>{seoData.seoText}</p>
          </div> */}
        </div>
      </div>
    </section>
  );
}
